import { IconButton, IconType, Popup, PopupSize } from 'features/nekst-widgets';
import { WebhookSubscription } from 'nekst-api';
import React from 'react';
import { usePopupManager, useShowContextRequired } from 'ui-builder';
import WebhookRequestsLogEntriesList from './WebhookRequestsLogEntriesList';

export default function WebhookRequestLogEntriesButton() {
  const { data } = useShowContextRequired<WebhookSubscription>();

  const popupManager = usePopupManager();

  return (
    <IconButton
      type={IconType.HELP}
      onClick={() => {
        popupManager.openPopup(
          <Popup
            size={PopupSize.WIDE}
            title="Webhook Requests Log"
            content={<WebhookRequestsLogEntriesList subscriptionId={data!.id} />}
          />
        );
      }}
    />
  );
}
